module.exports = __webpack_public_path__ + "static/media/home_image.2b17075c.jpg";